import { getFileIcon } from '@/components/FileType';
import { useState, useEffect } from 'react';
import { fileTypeMap } from '@/utils/Page/constant';
import s from './style.module.scss';
const IconImg = (props) => {
    console.log(props, '哈哈');
    const { className, file, ing } = props;
    const [src, setSrc] = useState('');

    useEffect(() => {
        let temSrc = file?.favicon || getFileIcon({ suffix: file.type === fileTypeMap.link ? 'link' : file?.ext_type });
        setSrc(temSrc);
    }, [file]);
    const onImgError = () => {
        console.log('图片加载失败', file);
        let temSrc = getFileIcon({ suffix: file.type === fileTypeMap.link ? 'link' : file?.ext_type });
        setSrc(temSrc);
    };
    return <img onError={onImgError} className={`${className} ${ing ? s['ing'] : ''}`} src={src} alt="" />;
};
export default IconImg;
